module.exports = __webpack_public_path__ + "static/media/11_sognolucido.4c73a2b1.jpg";